import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useState } from 'react'
import { Card, Dropdown, Menu } from 'antd'
import { connect } from 'react-redux'
import { CommentOutlined } from '@ant-design/icons'
import { isApproved, isUserAllowed, sendUserDataToGTM } from 'modules/core/utils'
import { CardBodyKpi, CardData, CardExtra, CardTitle, EmptyKpis } from './components'
import { handleDelete, handleDuplicate, handleEdit, handleOnChange } from './utils'
import { useSortable } from '@dnd-kit/sortable'
import { useParams } from 'react-router-dom'
import login from 'modules/login'
import configuration from 'modules/configuration'
import _ from 'lodash'

import './ProjectionCard.scss'
import { CONCEPTS, GENERAL, PROJECTION } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import Typography from 'modules/core/components/Typography/Typography'
import PropTypes from 'prop-types'
import { useCommentData } from 'modules/core/customHooks'

const isGlobal = (type) => type === 'globalBudget' || type === 'globalForecast'

const ProjectionCard = ({
  budgetId,
  title,
  conceptId = null,
  kpi = null,
  type,
  role,
  status,
  onOpen,
  onOpenActivities,
  reloadList,
  is_closing,
  onEditName,
  onDeleteBudget,
  extraFooter,
  duplicateCard,
  dataLineChart = [],
  dataRankingUp = [],
  allDimensionsList = [],
  dimension,
  setDimensionId,
  defaultColor,
  changeCardColor,
  module,
  budgets_ids,
  conceptName,
  hasComment,
  setHasComment,
  loggedUser,
  setDataComments,
  dataComments,
  onRefetchComments,
  loadingComments,
  setIsSaving,
  url,
}) => {
  const enabledRevampCard = useFeatureIsOn('feature-revamp-card')
  const extraConcept = useFeatureIsOn('feature-extra-concept')
  const enableKpis = useFeatureIsOn('feature-visible-kpi')
  const [titleValue, setTitleValue] = useState(title)
  const [budgetDelete, setBudgetDelete] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [editName, setEditName] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [color, setColor] = useState(defaultColor)
  const [showPopover, setShowPopover] = useState(false)
  const [viewComment, setViewComment] = useState(false)

  const { t } = useTranslation()

  let { periodId } = useParams()

  const { isDragging, attributes, listeners, setNodeRef, transform } = useSortable({ id: budgetId })

  const auxKey = window.location.pathname.replaceAll('/', '-')
  const key = !auxKey.includes('?tab=') ? `${auxKey}?tab=${type}` : auxKey

  const commentData = useCommentData({ hasComment, key, id: budgetId })

  const draggableStyle = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        userSelect: 'none',
        cursor: 'move',
        opacity: isDragging ? 0.5 : 1,
      }
    : undefined

  const tagStyle = {
    cursor: transform ? 'move' : 'pointer',
  }

  const auxIdOrType = conceptId ? conceptId : type

  const onCloseEdit = () => {
    setEditName(false)
    setIsEditing(false)
  }

  const onCloseDelete = () => {
    setIsDeleting(false)
    setBudgetDelete(false)
  }

  const onDuplicate = () => {
    if (isGlobal(type)) {
      const aux = budgets_ids.map((el) => {
        const id = _.keys(el)[0]
        return {
          concept_id: id,
          ...(type === 'globalBudget'
            ? {
                planning_id: el[id],
              }
            : {
                forecast_id: el[id],
              }),
        }
      })
      return duplicateCard({ name: title, period_id: periodId, overall_budget: aux })
    } else {
      return duplicateCard(budgetId)
    }
  }

  const permission = [
    PROJECTION.GLOBAL_BUDGET.toString(),
    PROJECTION.GLOBAL_FORECAST.toString(),
    CONCEPTS.IDS.SALES_ID.toString(),
    CONCEPTS.IDS.EXPENSES_ID.toString(),
    CONCEPTS.IDS.COSTS_ID.toString(),
    CONCEPTS.IDS.HUMAN_RESOURCES_ID.toString(),
    CONCEPTS.IDS.OTHER_5_ID.toString(),
    CONCEPTS.IDS.OTHER_6_ID.toString(),
    CONCEPTS.IDS.OTHER_7_ID.toString(),
    CONCEPTS.IDS.OTHER_7_ID.toString(),
  ]

  const verifyABM = (concept_id) => {
    if (permission.includes(concept_id.toString())) {
      return isUserAllowed(role[concept_id].ABM)
    } else if (extraConcept) {
      return true
    }

    return false
  }

  const verifyVIEW = (concept_id) => {
    if (permission.includes(concept_id.toString())) {
      return isUserAllowed(role[concept_id].VIEW)
    } else if (extraConcept) {
      return true
    }

    return false
  }

  const onSendTM = (action, type) => {
    if (module === 'planning')
      return sendUserDataToGTM(loggedUser, 'Planificación', `${action} presupuesto`, `${type}`)
    if (module === 'forecast')
      return sendUserDataToGTM(loggedUser, 'Forecast', `${action} instancia Forecast`, `${type}`)
    if (module === 'globalBudget')
      return sendUserDataToGTM(
        loggedUser,
        'Presupuesto global',
        `${action} presupuesto global`,
        `${type}`,
      )
    if (module === 'globalForecast')
      return sendUserDataToGTM(
        loggedUser,
        'Re-proyección global',
        `${action} re-proyección global`,
        `${type}`,
      )
  }

  const renderCardExtra = () => (
    <CardExtra
      status={status}
      title={title}
      loading={isDeleting}
      type={type} // Pasa la prop 'type' al componente CardExtra
      onConfirmPopconfirm={(e) => {
        e.stopPropagation()
        handleDelete({
          setIsLoading: setIsDeleting,
          onDeleteBudget: () => onDeleteBudget(budgetId),
          onRefetch: reloadList,
          onClose: onCloseDelete,
          sendUserDataToGTM: () => onSendTM('Eliminar', 'Eliminación'),
        })
      }}
      onCancelPopconfirm={(e) => {
        e.stopPropagation()
        setBudgetDelete(false)
      }}
      visible={budgetDelete}
      onClickEdit={(e) => {
        e.domEvent.stopPropagation()
        setEditName(true)
      }}
      disabled={!verifyABM(auxIdOrType) || isApproved(status)}
      onClickDuplicate={(e) => {
        e.domEvent.stopPropagation()
        handleDuplicate({
          setIsLoading: setIsSaving,
          duplicateCard: () => onDuplicate(),
          onRefetch: reloadList,
          onClose: () => setIsSaving(false),
          sendUserDataToGTM: () => onSendTM('Duplicar', 'Duplicación'),
        })
      }}
      onClickDelete={(e) => {
        e.domEvent.stopPropagation()
        setBudgetDelete(true)
      }}
      is_closing={is_closing}
      onOpenActivities={onOpenActivities}
      attributes={attributes}
      listeners={listeners}
      tagStyle={tagStyle}
      className="drag-card-icon"
      setColor={setColor}
      color={color}
      onClickCancelSaveColor={(e) => {
        e.stopPropagation()
        setColor(defaultColor)
        setShowPopover(false)
      }}
      onClickSaveColor={(e) => {
        e.stopPropagation()
        handleOnChange({
          changeCardColor: () => changeCardColor({ color, card_id: budgetId, type: module }),
          onConfirm: () => setShowPopover(false),
          onClose: () => {
            setShowPopover(false)
            setColor(defaultColor)
          },
        })
      }}
      open={showPopover}
      onClickIconColor={(e) => {
        e.stopPropagation()
        setShowPopover(true)
      }}
      viewComment={viewComment}
      hasComment={hasComment}
      setHasComment={setHasComment}
      setViewComment={setViewComment}
      loggedUser={loggedUser}
      setDataComments={setDataComments}
      dataComments={dataComments}
      onRefetchComments={onRefetchComments}
      loadingComments={loadingComments}
      cardId={budgetId}
      module={module}
    />
  )

  const renderCardTitle = () => (
    <CardTitle
      isEditing={isEditing}
      editName={editName}
      handleEdit={(value) =>
        handleEdit({
          value,
          titleValue,
          setIsLoading: setIsEditing,
          onEditName: () => onEditName(budgetId, { name: value }),
          onClose: onCloseEdit,
          setTitleValue,
          sendUserDataToGTM: () => onSendTM('Editar', 'Edición'),
        })
      }
      titleValue={titleValue}
      style={{ width: 180 }}
    />
  )

  const renderBody = () => {
    if (!enableKpis) {
      return <Typography.Body>{t('NOT_VIEW_INFORMATION')}</Typography.Body>
    }
    return <CardData kpi={kpi} />
  }

  const renderDefaultCard = () => {
    return (
      <Dropdown
        trigger={['contextMenu']}
        overlay={
          <Menu>
            {GENERAL.OPTION_COMMENT.map((el) => (
              <Menu.Item
                key={el.key}
                icon={<CommentOutlined />}
                onClick={() => {
                  setViewComment(true)
                  setHasComment({
                    type: 'card',
                    data: commentData,
                    key,
                    id: budgetId,
                  })
                }}
              >
                {t(el.label)}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Card
          title={renderCardTitle()}
          className={`tracing-list-card`}
          style={{ boxShadow: `0px -3px 0px ${color}` }}
          headStyle={{ height: 56, padding: '0px 20px' }}
          bodyStyle={{ height: 128, display: 'flex', alignItems: 'center' }}
          bordered={false}
          onClick={verifyVIEW(auxIdOrType) && onOpen}
          onMouseDown={(e) => {
            if (e.button === 1) {
              window.open(url(), '_blank')
            }
          }}
          extra={renderCardExtra()}
          loading={isDeleting}
        >
          {kpi !== null && renderBody()}
          {kpi === null && <EmptyKpis />}
        </Card>
      </Dropdown>
    )
  }

  const renderRevampCard = () => {
    return (
      <Dropdown
        trigger={['contextMenu']}
        overlay={
          <Menu>
            {GENERAL.OPTION_COMMENT.map((el) => (
              <Menu.Item
                key={el.key}
                icon={<CommentOutlined />}
                onClick={() => {
                  setViewComment(true)
                  setHasComment({
                    type: 'card',
                    data: commentData,
                    key,
                    id: budgetId,
                  })
                }}
              >
                {t(el.label)}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Card
          className="tracing-list-card"
          style={{ boxShadow: `0px -3px 0px ${color}`, margin: '0px 5px' }}
        >
          <CardBodyKpi
            title={title}
            loading={isDeleting}
            onConfirmPopconfirm={() =>
              handleDelete({
                setIsLoading: setIsDeleting,
                onDeleteBudget: () => onDeleteBudget(budgetId),
                onRefetch: reloadList,
                onClose: onCloseDelete,
              })
            }
            onCancelPopconfirm={() => setBudgetDelete(false)}
            visible={budgetDelete}
            onClickEdit={() => setEditName(true)}
            disabled={!isUserAllowed(role[auxIdOrType].ABM) || isApproved(status)}
            onClickDuplicate={() =>
              handleDuplicate({
                setIsLoading: setIsSaving,
                duplicateCard: () => duplicateCard(budgetId),
                onRefetch: reloadList,
                onClose: () => setIsSaving(false),
              })
            }
            onClickDelete={() => setBudgetDelete(true)}
            onOpenActivities={onOpenActivities}
            type={type}
            attributes={attributes}
            listeners={listeners}
            tagStyle={tagStyle}
            onOpen={onOpen}
            is_closing={is_closing}
            status={status}
            kpi={kpi}
            dataLineChart={dataLineChart}
            dataRankingUp={dataRankingUp}
            allDimensionsList={allDimensionsList}
            editName={editName}
            dimension={dimension}
            setDimensionId={setDimensionId}
            open={showPopover}
            color={color}
            setColor={setColor}
            onClickCancelSaveColor={() => {
              setColor(defaultColor)
              setShowPopover(false)
            }}
            onClickSaveColor={() =>
              handleOnChange({
                changeCardColor: () => changeCardColor({ color, card_id: budgetId, type: module }),
                onConfirm: () => setShowPopover(false),
                onClose: () => {
                  setShowPopover(false)
                  setColor(defaultColor)
                },
              })
            }
            onClickIconColor={() => setShowPopover(true)}
            isEditing={isEditing}
            handleEdit={(value) =>
              handleEdit({
                value,
                titleValue,
                setIsLoading: setIsEditing,
                onEditName: () => onEditName(budgetId, { name: value }),
                onClose: onCloseEdit,
                setTitleValue,
              })
            }
            titleValue={titleValue}
            conceptName={conceptName}
            loggedUser={loggedUser}
            hasComment={hasComment}
            setHasComment={setHasComment}
            viewComment={viewComment}
            setViewComment={setViewComment}
            setDataComments={setDataComments}
            dataComments={dataComments}
            onRefetchComments={onRefetchComments}
            loadingComments={loadingComments}
            cardId={budgetId}
            module={module}
          />
        </Card>
      </Dropdown>
    )
  }

  const getRenderCard = (type) => {
    if (isGlobal(type)) {
      return renderDefaultCard()
    }
    if (enabledRevampCard) {
      return renderRevampCard()
    }
    return renderDefaultCard()
  }

  return (
    <div ref={setNodeRef} style={draggableStyle}>
      {getRenderCard(type)}
    </div>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
  hasComment: configuration.selectors.getHasComment(state),
})

const mapDispatchToProps = {
  setHasComment: configuration.actions.setHasComment,
}

ProjectionCard.propTypes = {
  duplicateCard: PropTypes.func,
  dataLineChart: PropTypes.array,
  dataRankingUp: PropTypes.array,
  allDimensionsList: PropTypes.array,
  dimension: PropTypes.any,
  setDimensionId: PropTypes.func,
  defaultColor: PropTypes.string,
  changeCardColor: PropTypes.func,
  module: PropTypes.string,
  budgets_ids: PropTypes.any,
  conceptName: PropTypes.string,
  hasComment: PropTypes.shape({
    card: PropTypes.object,
  }),
  setHasComment: PropTypes.func,
  loggedUser: PropTypes.object,
  setDataComments: PropTypes.func,
  dataComments: PropTypes.any,
  onRefetchComments: PropTypes.func,
  loadingComments: PropTypes.bool,
  setIsSaving: PropTypes.func,
  url: PropTypes.string,
  role: PropTypes.arrayOf(
    PropTypes.shape({
      ABM: PropTypes.any,
      VIEW: PropTypes.any,
    }),
  ),
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectionCard)
